import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TrashIcon } from "@heroicons/react/24/outline";
import classNames from "../../../helpers/classNames";
import { useEditor } from "../../../hooks/EditorProvider";
const RepeatGroup = ({ children, group, index, editable, elementId, }) => {
    const { deleteRepeatElementProp } = useEditor();
    const deleteItem = () => {
        deleteRepeatElementProp(elementId, group, index);
    };
    if (editable) {
        return (_jsxs("div", { className: classNames("hover:border-app-500 relative w-full border border-dashed p-1"), children: [index && !index.includes("default") && (_jsx("button", { onClick: deleteItem, type: "button", className: "bg-app-600 hover:bg-app-700 absolute -top-3 right-1 z-50 inline-flex items-center rounded-lg border border-transparent p-1 text-white shadow-sm focus:outline-none focus:ring-0", children: _jsx(TrashIcon, { className: "h-4 w-4", "aria-hidden": "true" }) })), children || null] }));
    }
    return children || null;
};
export default RepeatGroup;
//# sourceMappingURL=RepeatGroup.js.map